import React, { useEffect, useState } from "react";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import Fuse from "fuse.js";
import Label from "@material-tailwind/react/Label";
import Select from "react-select";

import { useDispatch, useSelector } from "react-redux";
import Alert from "@material-tailwind/react/Alert";
import {
  userAdminSlice,
  userMin,
  userMinAll,
} from "../../../features/setup/user/userSlice";
import {
  getMinProvinsi,
  provinsiSelector,
} from "../../../features/master/provinsi/provinsiSlice";
import {
  getMinGolongan,
  golonganSelector,
} from "../../../features/master/golongan/golonganSlice";
import {
  getMinTipeKaryawan,
  tipeKaryawanSelector,
} from "../../../features/master/tipe-karyawan/tipeKaryawanSlice";
import {
  getMinMainAccount,
  mainAccountSelector,
} from "../../../features/master/main-account/mainAccountSlice";
import {
  getMinSubAccount,
  subAccountSelector,
} from "../../../features/master/sub-account/subAccountSlice";
import {
  getMinSubGroupAccount,
  subGroupAccountSelector,
} from "../../../features/master/sub-group-account/subGroupAccountSlice";
import {
  detailAccountSelector,
  getMinDetailAccount,
} from "../../../features/master/activity/detail-account/detailAccountSlice";
import {
  getMinKelompokKegiatan,
  kelompokKegiatanSelector,
} from "../../../features/master/kelompok-kegiatan/kelompokKegiatanSlice";
import {
  getMinSubKegiatan,
  subKegiatanSelector,
} from "../../../features/master/sub-kegiatan/subKegiatanSlice";
import {
  getMinSatuan,
  satuanSelector,
} from "../../../features/master/satuan/satuanSlice";

import "./SelectSearch.css";
import {
  getMinKlien,
  klienSelector,
} from "../../../features/master/klien/klienSlice";
import DatePicker from "react-datepicker";
// import TimePicker from "react-time-picker";

const fuzzySearch = (options) => {
  const fuse = new Fuse(options, {
    keys: ["name", "groupName", "items.name"],
    threshold: 0.3,
  });

  return (value) => {
    if (!value.length) {
      return options;
    }

    return fuse.search(value);
  };
};

const InputField = (props) => {
  return (
    <div className="flex flex-wrap -mx-3 mb-2">
      <div className="w-full px-3">
        <label
          className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
          htmlFor="input-one"
        >
          {props.title}
        </label>
        <input
          className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white"
          id="grid-first-name"
          type="text"
          placeholder={props.placeholder ? props.placeholder : ""}
          // value={inputOneValue}
          // onChange={(e) => {
          //   setInputOneValue(e.target.value);
          // }}
        />
        {/* <p className="text-red-500 text-xs italic">
                  Please fill out this field.
                </p> */}
      </div>
    </div>
  );
};

const DropdownField = (props) => {
  return (
    <div className="flex flex-wrap -mx-3 mb-2">
      <div className="w-full px-3">
        <label
          className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
          htmlFor="status"
        >
          {props.title}
        </label>
        <div className="inline-block relative w-full">
          <select
            value={props.addEnabled ? "" : props.editEnabled && props.value}
            // onChange={(e) => props.setDropdownValue(e.target.value)}
            className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          >
            {props.dropdownData.map((item, i) => (
              <option key={"dropdown-" + i} value={item.value}>
                {item.name}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function ModalForm(props) {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(props.showModal);

  const [addEnabled, setAddEnabled] = useState(
    props.addEnabled ? props.addEnabled : false
  );
  const [editEnabled, setEditEnabled] = useState(
    props.editEnabled ? props.editEnabled : false
  );

  const [alertEnable, setalertEnable] = useState(
    props.alertEnable ? props.alertEnable : false
  );

  const [alertValue, setalertValue] = useState(
    props.alertValue ? props.alertValue : ""
  );
  // const [dropdownOneValue, setDropdownOneValue] = useState("");

  // const [inputOneValue, setInputOneValue] = useState("");

  const [dropdownOneValue, setDropdownOneValue] = useState(
    props.dropdownOneData ? props.dropdownOneData[0].ProvinsiID : ""
  );

  const [dropdownUserAdmin, setDropdownUserAdmin] = useState(
    props.dropdownUserAdmin ? props.dropdownUserAdmin : ""
  );

  const [dropdownKaryawanValue, setDropdownKaryawanValue] = useState(
    props.dropdownKaryawanValue ? props.dropdownKaryawanValue : ""
  );

  const [dropdownProvinsiValue, setDropdownProvinsiValue] = useState(
    props.dropdownProvinsiValue ? props.dropdownProvinsiValue : ""
  );

  const [dropdownClient, setdropdownClient] = useState(
    props.dropdownClientValue ? props.dropdownClientValue : ""
  );

  const [dropdownGolonganValue, setDropdownGolonganValue] = useState(
    props.dropdownGolonganValue ? props.dropdownGolonganValue : ""
  );

  const [dropdownTipeKaryawanValue, setDropdownTipeKaryawanValue] = useState(
    props.dropdownTipeKaryawanValue ? props.dropdownTipeKaryawanValue : ""
  );

  const [dropdownMainAccountValue, setDropdownMainAccountValue] = useState(
    props.dropdownMainAccountValue ? props.dropdownMainAccountValue : ""
  );

  const [dropdownSubAccountValue, setDropdownSubAccountValue] = useState(
    props.dropdownSubAccountValue ? props.dropdownSubAccountValue : ""
  );

  // Saldo Normal (Debit/Kredit) — dipakai pada Master Sub Group Account.
  const [dropdownNormalValue, setDropdownNormalValue] = useState(
    props.dropdownNormalValue ? props.dropdownNormalValue : "D"
  );

  const [dropdownSubGroupAccountValue, setDropdownSubGroupAccountValue] =
    useState(
      props.dropdownSubGroupAccountValue
        ? props.dropdownSubGroupAccountValue
        : ""
    );

  const [dropdownDetailAccountValue, setDropdownDetailAccountValue] = useState(
    props.dropdownDetailAccountValue ? props.dropdownDetailAccountValue : ""
  );

  const [dropdownLawanAccountValue, setDropdownLawanAccountValue] = useState(
    props.dropdownLawanAccountValue ? props.dropdownLawanAccountValue : ""
  );

  const [dropdownLawanBebanAccountValue, setDropdownLawanBebanAccountValue] = useState(
    props.dropdownLawanBebanAccountValue ? props.dropdownLawanBebanAccountValue : ""
  );

  const [dropDownOumValue, setdropDownOumValue] = useState(
    props.dropDownOumValue ? props.dropDownOumValue : ""
  );
  const [dropDownRentalValue, setdropDownRentalValue] = useState(
    props.dropDownRentalValue ? props.dropDownRentalValue : ""
  );
  const [dropDownAreaRentalValue, setdropDownAreaRentalValue] = useState(
    props.dropDownAreaRentalValue ? props.dropDownAreaRentalValue : ""
  );
  const [dropDownRentalUnitValue, setdropDownRentalUnitValue] = useState(
    props.dropDownRentalUnitValue ? props.dropDownRentalUnitValue : ""
  );

  const [dropDownGeneralServiceUnitValue, setdropDownGeneralServiceUnitValue] =
    useState(
      props.dropDownGeneralServiceUnitValue
        ? props.dropDownGeneralServiceUnitValue
        : ""
    );

  const [dropDownKemasanValue, setdropDownKemasanValue] = useState(
    props.dropDownKemasanValue ? props.dropDownKemasanValue : ""
  );

  const [dropDownGudangValue, setdropDownGudangValue] = useState(
    props.dropDownGudangValue ? props.dropDownGudangValue : ""
  );
  const [dropDownCargoValue, setdropDownCargoValue] = useState(
    props.dropDownCargoValue ? props.dropDownCargoValue : ""
  );
  const [dropDownWasteValue, setdropDownWasteValue] = useState(
    props.dropDownWasteValue ? props.dropDownWasteValue : ""
  );
  const [startDate, setStartDate] = useState(
    props.startDateValue ? new Date(props.startDateValue) : new Date()
  );
  const [endDate, setEndDate] = useState(new Date());
  const [dropDownType, setdropDownType] = useState(
    props.dropDownValue ? props.dropDownValue : ""
  );
  const [dropDownDayValue, setdropDownDayValue] = useState(
    props.dropDownDayValue ? props.dropDownDayValue : ""
  );
  const [dropDownJenisValue, setdropDownJenisValue] = useState(
    props.dropDownJenisValue ? props.dropDownJenisValue : ""
  );
  const [dropDownKendaraanValue, setdropDownKendaraanValue] = useState(
    props.dropDownKendaraanValue ? props.dropDownKendaraanValue : ""
  );

  const [dropdownKelompokKegiatanValue, setDropdownKelompokKegiatanValue] =
    useState(
      props.dropdownKelompokKegiatanValue
        ? props.dropdownKelompokKegiatanValue
        : ""
    );

  const [dropdownSubKegiatanValue, setDropdownSubKegiatanValue] = useState(
    props.dropdownSubKegiatanValue ? props.dropdownSubKegiatanValue : ""
  );

  const [dropdownSatuanValue, setDropdownSatuanValue] = useState(
    props.dropdownSatuanValue ? props.dropdownSatuanValue : ""
  );

  const [inputOneValue, setInputOneValue] = useState(
    props.inputOneValue ? props.inputOneValue : ""
  );

  const [inputTwoValue, setInputTwoValue] = useState(
    props.inputTwoValue ? props.inputTwoValue : ""
  );

  const [inputThreeValue, setInputThreeValue] = useState(
    props.inputThreeValue ? props.inputThreeValue : ""
  );

  const [inputFourValue, setInputFourValue] = useState(
    props.inputFourValue ? props.inputFourValue : ""
  );

  const [inputFiveValue, setInputFiveValue] = useState(
    props.inputFiveValue ? props.inputFiveValue : ""
  );

  const [inputSixValue, setInputSixValue] = useState(
    props.inputSixValue ? props.inputSixValue : ""
  );

  const [inputSevenValue, setInputSevenValue] = useState(
    props.inputSevenValue ? props.inputSevenValue : ""
  );

  const [inputEightValue, setInputEightValue] = useState(
    props.inputEightValue ? props.inputEightValue : ""
  );

  const [inputOnePlaceholder, setInputOnePlaceholder] = useState(
    props.inputOnePlaceholder ? props.inputOnePlaceholder : ""
  );

  const [inputTwoPlaceholder, setInputTwoPlaceholder] = useState(
    props.inputTwoPlaceholder ? props.inputTwoPlaceholder : ""
  );

  const [inputThreePlaceholder, setInputThreePlaceholder] = useState(
    props.inputThreePlaceholder ? props.inputThreePlaceholder : ""
  );

  const [inputFourPlaceholder, setInputFourPlaceholder] = useState(
    props.inputFourPlaceholder ? props.inputFourPlaceholder : ""
  );

  const [inputFivePlaceholder, setInputFivePlaceholder] = useState(
    props.inputFivePlaceholder ? props.inputFivePlaceholder : ""
  );

  const [inputSixPlaceholder, setInputSixPlaceholder] = useState(
    props.inputSixPlaceholder ? props.inputSixPlaceholder : ""
  );

  const [inputSevenPlaceholder, setInputSevenPlaceholder] = useState(
    props.inputSevenPlaceholder ? props.inputSevenPlaceholder : ""
  );

  const [inputEightPlaceholder, setInputEightPlaceholder] = useState(
    props.inputEightPlaceholder ? props.inputEightPlaceholder : ""
  );

  const [inputNumberOneValue, setInputNumberOneValue] = useState(
    props.inputNumberOneValue ? props.inputNumberOneValue : 0
  );
  const [inputNumberTwoValue, setInputNumberTwoValue] = useState(
    props.inputNumberTwoValue ? props.inputNumberTwoValue : 0
  );
  const [InputCheckValue, setInputCheckValue] = useState(
    props.InputCheckValue ? props.InputCheckValue : 0
  );
  const [BpjsksValue, setBpjsksValue] = useState(
    props.BpjsksValue ? props.BpjsksValue : 0
  );
  const [BpjstkValue, setBpjstkValue] = useState(
    props.BpjstkValue ? props.BpjstkValue : 0
  );

  const [status, setStatus] = useState(props.status ? props.status : "");

  const [countInputField, setCountInputField] = useState(0);
  const [countDropdownField, setCountDropdownField] = useState(0);

  const provinsi = useSelector(provinsiSelector);

  const user = useSelector(userAdminSlice);

  const golongan = useSelector(golonganSelector);

  const tipeKaryawan = useSelector(tipeKaryawanSelector);

  const mainAccount = useSelector(mainAccountSelector);

  const subAccount = useSelector(subAccountSelector);

  const subGroupAccount = useSelector(subGroupAccountSelector);

  const detailAccount = useSelector(detailAccountSelector);

  const kelompokKegiatan = useSelector(kelompokKegiatanSelector);
  const klien = useSelector(klienSelector);

  const subKegiatan = useSelector(subKegiatanSelector);
  const satuan = useSelector(satuanSelector);
  const oum = [
    { value: "1", label: "Port Service" },
    { value: "2", label: "Rental" },
    { value: "3", label: "Waste Service" },
    {
      value: "4",
      label: "Area Rental",
    },
    { value: "5", label: "General Service" },
  ];
  const rentalUnit = [
    { value: "1", label: "Heavy Equipment" },
    { value: "2", label: "Lifting Rigging Equipment" },
  ];
  const rental = [
    { value: "1", label: "Heavy Equipment" },
    { value: "2", label: "Lifting Rigging Equipment" },
  ];
  const areaRental = [
    { value: "1", label: "Area Rental" },
    { value: "2", label: "Pusat Logistik Berikat" },
    { value: "3", label: "Tubular Inspection Shop" },
  ];
  const generalServiceUnit = [
    { value: "1", label: "Light Vehicle" },
    { value: "2", label: "Medium Duty" },
    { value: "3", label: "Heavy Duty" },
  ];

  const gudang = [
    { value: "1", label: "Port Service" },
    { value: "2", label: "Wooden Dunnage" },
    { value: "3", label: "Pallate Wraping" },
    { value: "4", label: "Order Unit" },
    { value: "5", label: "Temporary Waste Storage" },
  ];
  const kemasan = [
    { value: "1", label: "Port Service" },
    { value: "2", label: "Waste Service" },
  ];
  const waste = [
    { value: "1", label: "Waste Handling" },
    { value: "2", label: "Hazardous Waste Storage" },
    { value: "3", label: "Hazardous Waste Transport & Disposal" },
  ];

  const cargo = [
    { value: "1", label: "Cargo Basket" },
    { value: "2", label: "Cutting Skips" },
    { value: "3", label: "Dry Goods Container & Container Open Top" },
    { value: "4", label: "Drum Baskets & Half Height Basket" },
    { value: "5", label: "Cages & Frame" },
    { value: "6", label: "Chemical & acid Tanks" },
  ];

  const kendaraan = [
    { value: "1", label: "Port Service" },
    { value: "2", label: "Waste Service" },
    { value: "3", label: "Order Unit" },
  ];
  const types = [
    { value: "1", label: "Type 1 (Lengkap)" },
    { value: "2", label: "Type 2 (Minim)" },
  ];

  const days = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];
  useEffect(() => {
    if (props.dropdownProvinsi) {
      dispatch(getMinProvinsi({ search: "" }));
    }

    if (props.dropdownUser) {
      dispatch(userMin());
    }
    if (props.dropdownKaryawan) {
      dispatch(userMinAll());
    }
    if (props.dropdownGolongan) {
      dispatch(getMinGolongan({ search: "" }));
    }
    if (props.dropdownTipeKaryawan) {
      dispatch(getMinTipeKaryawan({ search: "" }));
    }
    if (props.dropdownMainAccount) {
      dispatch(
        getMinMainAccount({
          search: "",
        })
      );
    }
    if (props.dropDownKlien) {
      dispatch(
        getMinKlien({
          search: "",
        })
      );
    }
    if (props.dropdownSubAccount) {
      dispatch(
        getMinSubAccount({
          search: "",
        })
      );
    }
    if (props.dropdownSubGroupAccount) {
      dispatch(
        getMinSubGroupAccount({
          search: "",
        })
      );
    }
    if (props.dropdownDetailAccount || props.dropdownLawanAccount || props.dropdownLawanBebanAccount) {
      dispatch(
        getMinDetailAccount({
          search: "",
        })
      );
    }
    if (props.dropdownKelompokKegiatan) {
      dispatch(
        getMinKelompokKegiatan({
          search: "",
        })
      );
    }
    if (props.dropdownSubKegiatan) {
      dispatch(
        getMinSubKegiatan({
          search: "",
        })
      );
    }
    if (props.dropdownSatuan) {
      dispatch(
        getMinSatuan({
          search: "",
        })
      );
    }
  }, []);

  useEffect(() => {
    if (user.isMinSuccess && dropdownUserAdmin === "") {
      setDropdownUserAdmin(user.minData[0].Nik);
    }

    if (user.isMinAllSuccess && dropdownKaryawanValue === "") {
      setDropdownKaryawanValue(user.minDataAll[0].Nik);
    }
    if (provinsi.isMinSuccess && dropdownProvinsiValue === "") {
      setDropdownProvinsiValue(provinsi.minData[0].ProvinsiID);
    }
    if (golongan.isMinSuccess && dropdownGolonganValue === "") {
      setDropdownGolonganValue(golongan.minData[0].GolonganID);
    }
    if (tipeKaryawan.isMinSuccess && dropdownTipeKaryawanValue === "") {
      setDropdownTipeKaryawanValue(tipeKaryawan.minData[0].TipeKaryawanID);
    }
  });

  for (let i = 0; i < props.formData; i++) {
    if (props.formData[i].fieldType === "inputfield") {
      setCountInputField(countInputField + 1);
    }

    if (props.formData[i].fieldType === "dropdownfield") {
      setCountDropdownField(countDropdownField + 1);
    }
  }

  return (
    <>
      <Modal size="md" active={showModal} toggler={() => props.modal(false)}>
        <ModalHeader
          className="mt-20"
          toggler={() => {
            props.modal(false);
          }}
        >
          {props.modalTitle}
        </ModalHeader>
        <ModalBody>
          <form className="w-full max-w-lg">
            {editEnabled && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    ID
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-gray-100"
                    id="grid-first-name"
                    type="text"
                    placeholder={inputOnePlaceholder}
                    value={props.id}
                    disabled
                  />
                  {/* <p className="text-red-500 text-xs italic">
                  Please fill out this field.
                </p> */}
                </div>
              </div>
            )}
            {/* {props.formData.map((obj, i) =>
              obj.fieldType === "inputfield" ? (
                <InputField
                  key={"input-" + i}
                  title={obj.title}
                  placeholder={obj.placeholder}
                />
              ) : obj.fieldType === "dropdownfield" ? (
                <DropdownField
                  key={"dropdown-" + i}
                  addEnabled={addEnabled}
                  editEnabled={editEnabled}
                  search={obj.search}
                  handleSearch={obj.handleSearch}
                  title={obj.title}
                  placeholder={obj.placeholder}
                  dropdownData={obj.dropdownData}
                  handleValue={setDropdownOneValue}
                />
              ) : null
            )} */}
            {/* {
              props.formData && <InputField title={"tes"} placeholder={"wew"} />
            } */}

            {props.dropdownOneData && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    {props.dropdownOneTitle}
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={status}
                      onChange={(e) => setDropdownOneValue(e.target.value)}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      {props.dropdownOneData.map((item, i) => (
                        <option key={item.ProvinsiID} value={item.ProvinsiID}>
                          {item.NamaProvinsi}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownProvinsi && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Provinsi
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownProvinsiValue}
                      onChange={(e) =>
                        setDropdownProvinsiValue(e.target.value.provinsiID)
                      }
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      {provinsi.minData.map((item, i) => (
                        <option key={item.provinsiID} value={item.provinsiID}>
                          {item.NamaProvinsi}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropDownKlien && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Client
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownClient}
                      onChange={(e) => setdropdownClient(e.target.value)}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      {klien.minData.map((item, i) => (
                        <option key={item.value} value={item.value}>
                          {item["label"]}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownUser && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Karyawan
                  </label>

                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownUserAdmin}
                      onChange={(e) => setDropdownUserAdmin(e.target.value)}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      {user.minDataAll.map((item, i) => (
                        <option key={item.Nik} value={item.Nik}>
                          {item.NamaKaryawan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                  <Label className="mt-2" color="orange">
                    Karyawan hanya dapat memiliki 1 akun
                  </Label>
                </div>
              </div>
            )}
            {props.dropdownGolongan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Golongan
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownGolonganValue}
                      onChange={(e) => setDropdownGolonganValue(e.target.value)}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      {golongan.minData.map((item, i) => (
                        <option key={item.GolonganID} value={item.GolonganID}>
                          {item.NamaGolongan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownTipeKaryawan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Tipe Karyawan
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownTipeKaryawanValue}
                      onChange={(e) =>
                        setDropdownTipeKaryawanValue(e.target.value)
                      }
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      {tipeKaryawan.minData.map((item, i) => (
                        <option
                          key={item.TipeKaryawanID}
                          value={item.TipeKaryawanID}
                        >
                          {item.NamaTipeKaryawan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownMainAccount && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Nama Main Account
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownMainAccountValue}
                      onChange={(e) =>
                        setDropdownMainAccountValue(e.target.value)
                      }
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {mainAccount.minData.map((item, i) => (
                        <option
                          key={item.MainAccountID}
                          value={item.MainAccountID}
                        >
                          {item.MainAccount}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownSubAccount && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Nama Sub Account
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      disabled={dropdownMainAccountValue === ""}
                      value={dropdownSubAccountValue}
                      onChange={(e) => {
                        setDropdownSubAccountValue(e.target.value);
                      }}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {subAccount.minData.map((item, i) => (
                        <option
                          key={"sub-account-" + item.SubAccountID}
                          value={item.SubAccountID}
                        >
                          {item.SubAccount}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownNormal && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="saldoNormal"
                  >
                    Saldo Normal
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownNormalValue}
                      onChange={(e) => {
                        setDropdownNormalValue(e.target.value);
                      }}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="D">Debit</option>
                      <option value="K">Kredit</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownSubGroupAccount && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Nama Sub Group Account
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      disabled={dropdownSubAccountValue === ""}
                      value={dropdownSubGroupAccountValue}
                      onChange={(e) =>
                        setDropdownSubGroupAccountValue(e.target.value)
                      }
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {subGroupAccount.minData.map((item, i) => (
                        <option
                          key={"sub-group-account-" + item.SubGroupAccountID}
                          value={item.SubGroupAccountID}
                        >
                          {item.SubGroupAccount}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownDetailAccount && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Nama Detail Account
                  </label>
                  <Select
                    placeholder="-- Pilih Detail Account --"
                    value={
                      dropdownDetailAccountValue
                        ? detailAccount.minData
                            .map((item) => ({
                              value: item.DetailAccountID,
                              label: item.DetailAccountID + " - " + item.DetailAccount,
                            }))
                            .find((opt) => opt.value === dropdownDetailAccountValue) || null
                        : null
                    }
                    onChange={(selected) =>
                      setDropdownDetailAccountValue(selected ? selected.value : "")
                    }
                    options={detailAccount.minData.map((item) => ({
                      value: item.DetailAccountID,
                      label: item.DetailAccountID + " - " + item.DetailAccount,
                    }))}
                    isClearable
                  />
                </div>
              </div>
            )}
            {props.dropdownLawanAccount && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="lawanAccount"
                  >
                    Akun Lawan (Hutang)
                  </label>
                  <Select
                    placeholder="-- Pilih Akun Lawan --"
                    value={
                      dropdownLawanAccountValue
                        ? detailAccount.minData
                            .map((item) => ({
                              value: item.DetailAccountID,
                              label: item.DetailAccountID + " - " + item.DetailAccount,
                            }))
                            .find((opt) => opt.value === dropdownLawanAccountValue) || null
                        : null
                    }
                    onChange={(selected) =>
                      setDropdownLawanAccountValue(selected ? selected.value : "")
                    }
                    options={detailAccount.minData.map((item) => ({
                      value: item.DetailAccountID,
                      label: item.DetailAccountID + " - " + item.DetailAccount,
                    }))}
                    isClearable
                  />
                </div>
              </div>
            )}
            {props.dropdownLawanBebanAccount && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="lawanBebanAccount"
                  >
                    Akun Lawan (Beban)
                  </label>
                  <Select
                    placeholder="-- Pilih Akun Lawan Beban --"
                    value={
                      dropdownLawanBebanAccountValue
                        ? detailAccount.minData
                            .map((item) => ({
                              value: item.DetailAccountID,
                              label: item.DetailAccountID + " - " + item.DetailAccount,
                            }))
                            .find((opt) => opt.value === dropdownLawanBebanAccountValue) || null
                        : null
                    }
                    onChange={(selected) =>
                      setDropdownLawanBebanAccountValue(selected ? selected.value : "")
                    }
                    options={detailAccount.minData.map((item) => ({
                      value: item.DetailAccountID,
                      label: item.DetailAccountID + " - " + item.DetailAccount,
                    }))}
                    isClearable
                  />
                </div>
              </div>
            )}
            {props.dropDownOum && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={oum.filter(
                        ({ value }) => value === dropDownOumValue
                      )}
                      onChange={(e) => {
                        setdropDownOumValue(e.value);
                      }}
                      options={oum}
                    />
                  </div>
                </div>
              </div>
            )}
            {props.dropDownRental && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={rental.filter(
                        ({ value }) => value === dropDownRentalValue
                      )}
                      onChange={(e) => {
                        setdropDownRentalValue(e.value);
                      }}
                      options={rental}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropDownAreaRental && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={areaRental.filter(
                        ({ value }) => value === dropDownAreaRentalValue
                      )}
                      onChange={(e) => {
                        setdropDownAreaRentalValue(e.value);
                      }}
                      options={areaRental}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropDownRentalUnit && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={rentalUnit.filter(
                        ({ value }) => value === dropDownRentalUnitValue
                      )}
                      onChange={(e) => {
                        setdropDownRentalUnitValue(e.value);
                      }}
                      options={rentalUnit}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropDownGeneralServiceUnit && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={generalServiceUnit.filter(
                        ({ value }) => value === dropDownGeneralServiceUnitValue
                      )}
                      onChange={(e) => {
                        setdropDownGeneralServiceUnitValue(e.value);
                      }}
                      options={generalServiceUnit}
                    />
                  </div>
                </div>
              </div>
            )}
            {props.dropDownKemasan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={kemasan.filter(
                        ({ value }) => value === dropDownKemasanValue
                      )}
                      onChange={(e) => {
                        setdropDownKemasanValue(e.value);
                      }}
                      options={kemasan}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropDownGudang && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={gudang.filter(
                        ({ value }) => value === dropDownGudangValue
                      )}
                      onChange={(e) => {
                        setdropDownGudangValue(e.value);
                      }}
                      options={gudang}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropDownCargo && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={cargo.filter(
                        ({ value }) => value === dropDownCargoValue
                      )}
                      onChange={(e) => {
                        setdropDownCargoValue(e.value);
                      }}
                      options={cargo}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropDownWaste && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={waste.filter(
                        ({ value }) => value === dropDownWasteValue
                      )}
                      onChange={(e) => {
                        setdropDownWasteValue(e.value);
                      }}
                      options={waste}
                    />
                  </div>
                </div>
              </div>
            )}
            {props.dropDownType && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Type
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={types.filter(
                        ({ value }) => value === dropDownType
                      )}
                      onChange={(e) => {
                        setdropDownType(e.value);
                      }}
                      options={types}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropDownKendaraan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={kendaraan.filter(
                        ({ value }) => value === dropDownKendaraanValue
                      )}
                      onChange={(e) => {
                        setdropDownKendaraanValue(e.value);
                      }}
                      options={kendaraan}
                    />
                  </div>
                </div>
              </div>
            )}

            {props.dropdownKelompokKegiatan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Kelompok Kegiatan
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownKelompokKegiatanValue}
                      onChange={(e) => {
                        setDropdownKelompokKegiatanValue(e.target.value);
                      }}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {kelompokKegiatan.minData.map((item, i) => (
                        <option
                          key={"sub-account-" + item.KelompokKegiatanID}
                          value={item.KelompokKegiatanID}
                        >
                          {item.NamaKelompokKegiatan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownSubKegiatan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Sub Kegiatan
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownSubKegiatanValue}
                      onChange={(e) => {
                        setDropdownSubKegiatanValue(e.target.value);
                      }}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {subKegiatan.minData.map((item, i) => (
                        <option
                          key={"sub-account-" + item.SubKegiatanID}
                          value={item.SubKegiatanID}
                        >
                          {item.NamaSubKegiatan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.dropdownKaryawan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Karyawan
                  </label>

                  <div className="inline-block relative w-full">
                    <Select
                      placeholder="-- Pilih Karyawan --"
                      value={
                        dropdownKaryawanValue
                          ? user.minDataAll
                              .map((item) => ({
                                value: item.Nik,
                                label: item.NamaKaryawan,
                              }))
                              .find((opt) => opt.value === dropdownKaryawanValue) || null
                          : null
                      }
                      onChange={(selected) =>
                        setDropdownKaryawanValue(selected ? selected.value : "")
                      }
                      options={user.minDataAll.map((item) => ({
                        value: item.Nik,
                        label: item.NamaKaryawan,
                      }))}
                    />
                  </div>
                </div>
              </div>
            )}
            {props.dropDownDay && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Day
                  </label>
                  <div className="inline-block relative w-full">
                    <Select
                      value={days.filter(
                        ({ value }) => value === dropDownDayValue
                      )}
                      onChange={(e) => {
                        setdropDownDayValue(e.value);
                      }}
                      options={days}
                    />
                  </div>
                </div>
              </div>
            )}
            {props.dropDownJenis && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="jenis"
                  >
                    Jenis
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropDownJenisValue}
                      onChange={(e) => setdropDownJenisValue(e.target.value)}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="" disabled hidden>-- Pilih Jenis --</option>
                      <option value="Room">Room</option>
                      <option value="Class Room">Class Room</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.inputOneTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputOneTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    inputMode={props?.inputOneType === "number" ? "decimal" : "text"}
                    placeholder={inputOnePlaceholder}
                    value={inputOneValue}
                    onChange={(e) => {
                      const v =
                        props?.inputOneType === "number"
                          ? e.target.value.replace(/[^0-9.]/g, "")
                          : e.target.value;
                      setInputOneValue(v);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
                  Please fill out this field.
                </p> */}
                </div>
              </div>
            )}
            {props.inputTwoTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputTwoTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    inputMode={props?.inputTwoType === "number" ? "decimal" : "text"}
                    placeholder={inputTwoPlaceholder}
                    value={inputTwoValue}
                    onChange={(e) => {
                      const v =
                        props?.inputTwoType === "number"
                          ? e.target.value.replace(/[^0-9.]/g, "")
                          : e.target.value;
                      setInputTwoValue(v);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
                  Please fill out this field.
                </p> */}
                </div>
              </div>
            )}
            {props.inputThreeTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputThreeTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type={props?.inputThreeType === "number" ? "number" : "text"}
                    placeholder={inputThreePlaceholder}
                    value={inputThreeValue}
                    onChange={(e) => {
                      setInputThreeValue(e.target.value);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
                  Please fill out this field.
                </p> */}
                </div>
              </div>
            )}
            {props.inputFourTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputFourTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type={props?.inputFourType === "number" ? "number" : "text"}
                    placeholder={inputFourPlaceholder}
                    value={inputFourValue}
                    onChange={(e) => {
                      setInputFourValue(e.target.value);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
      Please fill out this field.
    </p> */}
                </div>
              </div>
            )}
            {props.inputFiveTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputFiveTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    inputMode={props?.inputFiveType === "number" ? "decimal" : "text"}
                    placeholder={inputFivePlaceholder}
                    value={inputFiveValue}
                    onChange={(e) => {
                      const v =
                        props?.inputFiveType === "number"
                          ? e.target.value.replace(/[^0-9.]/g, "")
                          : e.target.value;
                      setInputFiveValue(v);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
      Please fill out this field.
    </p> */}
                </div>
              </div>
            )}
            {props.inputSixTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputSixTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    inputMode={props?.inputSixType === "number" ? "decimal" : "text"}
                    placeholder={inputSixPlaceholder}
                    value={inputSixValue}
                    onChange={(e) => {
                      const v =
                        props?.inputSixType === "number"
                          ? e.target.value.replace(/[^0-9.]/g, "")
                          : e.target.value;
                      setInputSixValue(v);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
      Please fill out this field.
    </p> */}
                </div>
              </div>
            )}
            {props.inputSevenTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputSevenTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    placeholder={inputSevenPlaceholder}
                    value={inputSevenValue}
                    onChange={(e) => {
                      setInputSevenValue(e.target.value);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
      Please fill out this field.
    </p> */}
                </div>
              </div>
            )}
            {props.inputEightTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputEightTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    placeholder={inputEightPlaceholder}
                    value={inputEightValue}
                    onChange={(e) => {
                      setInputEightValue(e.target.value);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
Please fill out this field.
</p> */}
                </div>
              </div>
            )}
            {props.StartDate && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    Start Date
                  </label>
                  <DatePicker
                    dateFormat="dd/MMMM/yyyy"
                    selected={startDate}
                    className={
                      "appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    }
                    onChange={(text) => setStartDate(text)}
                  />
                </div>
              </div>
            )}
            {props.EndDate && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    End Date
                  </label>
                  <DatePicker
                    dateFormat="dd/MMMM/yyyy"
                    selected={endDate}
                    className={
                      "appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    }
                    onChange={(text) => setEndDate(text)}
                  />
                </div>
              </div>
            )}
            {props.Hour && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    Hour
                  </label>
                  {/* <TimePicker /> */}
                  {/* <DatePicker
                    dateFormat="dd/MMMM/yyyy"
                    selected={endDate}
                    className={
                      "appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    }
                    onChange={(text) => setEndDate(text)}
                  /> */}
                </div>
              </div>
            )}

            {props.dropdownSatuan && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="px-3 w-full">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Nama Satuan
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={dropdownSatuanValue}
                      onChange={(e) => {
                        setDropdownSatuanValue(e.target.value);
                      }}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option defaultValue disabled value="" hidden>
                        -- Pilih Data --
                      </option>
                      {satuan.minData.map((item, i) => (
                        <option
                          key={"sub-account-" + item.SatuanID}
                          value={item.SatuanID}
                        >
                          {item.NamaSatuan}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.inputNumberOneTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputNumberOneTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    placeholder=""
                    value={inputNumberOneValue}
                    onChange={(e) => {
                      setInputNumberOneValue(e.target.value);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
                    Please fill out this field.
                  </p> */}
                </div>
              </div>
            )}
            {props.inputNumberTwoTitle && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    {props.inputNumberTwoTitle}
                  </label>
                  <input
                    className="appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-4 leading-tight focus:outline-none bg-white"
                    id="grid-first-name"
                    type="text"
                    placeholder=""
                    value={inputNumberTwoValue}
                    onChange={(e) => {
                      setInputNumberTwoValue(e.target.value);
                    }}
                  />
                  {/* <p className="text-red-500 text-xs italic">
                    Please fill out this field.
                  </p> */}
                </div>
              </div>
            )}

            {props.InputCheck && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    Is Shift
                  </label>
                  <input
                    value={`${InputCheckValue}`}
                    // name={`${props.name}`}
                    checked={InputCheckValue ?? true}
                    type="checkbox"
                    onChange={(e) => {
                      setInputCheckValue(e.target.checked);
                    }}
                  />
                </div>
              </div>
            )}
            {props.Bpjsks && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    BPJSKS
                  </label>
                  <input
                    value={`${BpjsksValue}`}
                    // name={`${props.name}`}
                    checked={BpjsksValue ?? true}
                    type="checkbox"
                    onChange={(e) => {
                      setBpjsksValue(e.target.checked);
                    }}
                  />
                </div>
              </div>
            )}
            {props.Bpjstk && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="input-one"
                  >
                    BPJSTK
                  </label>
                  <input
                    value={`${BpjstkValue}`}
                    // name={`${props.name}`}
                    checked={BpjstkValue ?? true}
                    type="checkbox"
                    onChange={(e) => {
                      setBpjstkValue(e.target.checked);
                    }}
                  />
                </div>
              </div>
            )}
            {props.warningalert && (
              <Label className="mt-2" color="green">
                Password akan disamakan dengan username (Harap ganti pada
                pertama kali login)
              </Label>
            )}
            {editEnabled && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <label
                    className="capitalize block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
                    htmlFor="status"
                  >
                    Status
                  </label>
                  <div className="inline-block relative w-full">
                    <select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      className="block appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value={0}>Tidak Aktif</option>
                      <option value={1}>Aktif</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {props.extraContent}
            {alertEnable && (
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <Alert color="orange">{alertValue}</Alert>
                </div>
              </div>
            )}
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="red"
            buttonType="link"
            onClick={() => {
              props.modal(false);
            }}
            ripple="dark"
          >
            Cancel
          </Button>

          <Button
            color="green"
            onClick={() => {
              props.modal(false);
              props.handleSubmit({
                dropDownKlienValue: dropdownClient,
                dropdownProvinsiValue: dropdownProvinsiValue,
                dropdownGolonganValue: dropdownGolonganValue,
                dropdownTipeKaryawanValue: dropdownTipeKaryawanValue,
                dropdownMainAccountValue: dropdownMainAccountValue,
                dropdownSubAccountValue: dropdownSubAccountValue,
                dropdownNormalValue: dropdownNormalValue,
                dropdownSubGroupAccountValue: dropdownSubGroupAccountValue,
                dropdownDetailAccountValue: dropdownDetailAccountValue,
                dropdownLawanAccountValue: dropdownLawanAccountValue,
                dropdownLawanBebanAccountValue: dropdownLawanBebanAccountValue,
                dropdownKelompokKegiatanValue: dropdownKelompokKegiatanValue,
                dropdownSubKegiatanValue: dropdownSubKegiatanValue,
                dropdownSatuanValue: dropdownSatuanValue,
                dropdownOneValue: dropdownOneValue,
                inputOneValue: inputOneValue,
                dropDownOumValue: dropDownOumValue,
                dropDownRentalValue: dropDownRentalValue,
                dropDownRentalUnitValue: dropDownRentalUnitValue,
                dropDownAreaRentalValue: dropDownAreaRentalValue,
                dropDownKemasanValue: dropDownKemasanValue,
                dropDownGeneralServiceUnitValue:
                  dropDownGeneralServiceUnitValue,
                dropDownGudangValue: dropDownGudangValue,
                dropDownWasteValue: dropDownWasteValue,
                dropDownCargoValue: dropDownCargoValue,
                dropDownKendaraanValue: dropDownKendaraanValue,
                dropDownDayValue: dropDownDayValue,
                dropDownJenisValue: dropDownJenisValue,
                inputTwoValue: inputTwoValue,
                inputThreeValue: inputThreeValue,
                inputFourValue: inputFourValue,
                inputFiveValue: inputFiveValue,
                inputSixValue: inputSixValue,
                inputSevenValue: inputSevenValue,
                inputEightValue: inputEightValue,
                inputNumberOneValue: inputNumberOneValue,
                inputNumberTwoValue: inputNumberTwoValue,
                InputCheckValue: InputCheckValue,
                BpjsksValue: BpjsksValue,
                BpjstkValue: BpjstkValue,
                status: status,
                dropdownUserAdmin: dropdownUserAdmin,
                dropdownKaryawanValue: dropdownKaryawanValue,
                startDate: startDate,
                endDate: endDate,
                dropDownType: dropDownType,
              });
            }}
            ripple="light"
          >
            {props.submitButtonTitle}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
